import type { TrackingData, TrackingEvents } from "../types/tracking";

import { SAN_HEADER, TRACKING_EVENT } from "../types/tracking/constants";

export class TrackingEvent {
  static trackHeader(san_Header: SAN_HEADER) {
    window.o_global.events<TrackingEvents>().emit(TRACKING_EVENT.SUBMIT, { san_Header });
  }

  static trackOnNextPageImpression(trackingData: TrackingData) {
    window.o_global.events<TrackingEvents>().emit(TRACKING_EVENT.ON_NEXT_PI, trackingData);
    window.o_global.debug.warn("Track on next PI submitting " + JSON.stringify(trackingData));
  }

  static track(trackingData: TrackingData) {
    window.o_global.events<TrackingEvents>().emit(TRACKING_EVENT.SUBMIT, trackingData);
    window.o_global.debug.warn("Track event submitting " + JSON.stringify(trackingData));
  }
}
